import { fetchPackDetails, fetchProjectPacks, searchKnowledge } from '../../api/knowledge.js'
import type { KnowledgeSearchResult, PackDetails, ProjectPackSummary } from '../../api/knowledge.js'
import { route } from '../../router.js'
import { renderPacksView } from './packs_render.js'

let packs: ProjectPackSummary[] = []
let selected: PackDetails | null = null
let searchQuery = ''
let searchResults: KnowledgeSearchResult[] = []
let loading = false
let error: string | null = null

route('/packs', () => {
  void renderPacksPage()
})

export async function renderPacksPage(): Promise<void> {
  document.title = 'Knowledge Packs — Grizzly'
  loading = true
  paint()
  try {
    const response = await fetchProjectPacks()
    packs = response.data
    if (!selected && packs[0]) selected = await fetchPackDetails(packs[0].packSlug)
    error = null
  } catch (err) {
    error = err instanceof Error ? err.message : 'Failed to load packs'
  } finally {
    loading = false
    paint()
  }
}

function paint(): void {
  const app = document.getElementById('app')
  if (!app) return
  app.innerHTML = renderPacksView({ packs, selected, searchQuery, searchResults, loading, error })
  bindPackView(app)
}

function bindPackView(root: HTMLElement): void {
  root.querySelector<HTMLFormElement>('#pack-search-form')?.addEventListener('submit', (event) => {
    event.preventDefault()
    const input = root.querySelector<HTMLInputElement>('#pack-search-input')
    searchQuery = input?.value ?? ''
    void runSearch()
  })
  root.querySelectorAll<HTMLButtonElement>('[data-pack-slug]').forEach((button) => {
    button.addEventListener('click', () => {
      const slug = button.dataset.packSlug
      if (slug) void selectPack(slug)
    })
  })
}

async function selectPack(slug: string): Promise<void> {
  loading = true
  paint()
  try {
    selected = await fetchPackDetails(slug)
    error = null
  } catch (err) {
    error = err instanceof Error ? err.message : 'Failed to load pack details'
  } finally {
    loading = false
    paint()
  }
}

async function runSearch(): Promise<void> {
  if (!searchQuery.trim()) {
    searchResults = []
    paint()
    return
  }
  loading = true
  paint()
  try {
    const response = await searchKnowledge(searchQuery)
    searchResults = response.data
    error = null
  } catch (err) {
    error = err instanceof Error ? err.message : 'Search failed'
  } finally {
    loading = false
    paint()
  }
}
